/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  report(id) {
    return axios.get(`${this.url}/${id}/report`);
  }

  failedContacts(id) {
    return axios.get(`${this.url}/${id}/failed_contacts`, {
      responseType: 'text',
    });
  }

  // Estimativa de investimento antes do disparo (86ajefd0h): contatos da audiencia x
  // tarifa da categoria do template (USD). Backend em CampaignEstimateService.
  estimate({ audience, category }) {
    return axios.post(`${this.url}/estimate`, { audience, category });
  }
}

export default new CampaignsAPI();
